import React from 'react';

import { AccordionItem } from '@radix-ui/react-accordion';
import { useTranslation } from 'react-i18next';

import { Chip, ChipColor, ChipSize } from '@pkg/components/Sections/Profile/Chip';
import { WalletAccountLabel } from '@pkg/components/Sections/Profile/WalletAccountLabel';

import { type NFTManagerFilter } from '@app/store/types/nft-manager';
import { type WalletReadonly } from '@app/store/types/user';

import { FilterContent, FilterHeading } from '../Filter';

export type FilterWalletsItem = WalletReadonly[number];

export type FilterWalletsProps = {
    items: WalletReadonly | null | undefined;
    itemsSelected: NFTManagerFilter['ownerAddress'];
    onItemClick: (wallet: FilterWalletsItem) => void;
    index: string;
};

export const FilterWallets = ({ items, itemsSelected, onItemClick, index }: FilterWalletsProps) => {
    const { t } = useTranslation(['yat_nft_manager']);

    if (items == null) {
        return null;
    }

    return (
        <AccordionItem value={index}>
            <FilterHeading disableUpperCase>{t('yat_nft_manager_filter_wallet')}</FilterHeading>
            <FilterContent style={{ paddingRight: '28px' }} height="170px">
                {items.map((wallet) => (
                    <Chip
                        key={wallet}
                        color={itemsSelected?.includes(wallet) ? ChipColor.Active : undefined}
                        size={ChipSize.Small}
                        onClick={() => onItemClick(wallet)}
                    >
                        <Chip.Interior>
                            <WalletAccountLabel account={wallet} />
                        </Chip.Interior>
                    </Chip>
                ))}
            </FilterContent>
        </AccordionItem>
    );
};
